import { render } from "./ExpandableFAQ.vue?vue&type=template&id=03cfbe4c&scoped=true"
import script from "./ExpandableFAQ.vue?vue&type=script&lang=js"
export * from "./ExpandableFAQ.vue?vue&type=script&lang=js"

import "./ExpandableFAQ.vue?vue&type=style&index=0&id=03cfbe4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cfbe4c"]])

export default __exports__